module.exports = __webpack_public_path__ + "static/media/fly0205.6cae2cd8.webp";